'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$74() {
  this.bHj = null;
  this.bHk = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$74 as $c_Lpresto_TwoFactorAuthView$$anon$74 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$74.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$74;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$74() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$74 as $h_Lpresto_TwoFactorAuthView$$anon$74 };
$h_Lpresto_TwoFactorAuthView$$anon$74.prototype = $p;
$p.P = (function() {
  if ((!this.bHk)) {
    this.bHj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.bHk = true;
  }
  return this.bHj;
});
var $d_Lpresto_TwoFactorAuthView$$anon$74 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$74, "presto.TwoFactorAuthView$$anon$74", ({
  Tf: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$74 as $d_Lpresto_TwoFactorAuthView$$anon$74 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$74.js.map
